import { Injectable } from "@angular/core";
import { MenuItem } from "primeng/api";

@Injectable()
export class ContextMenuService {
    show: (event: MouseEvent, menuItems: MenuItem[]) => void;
    close: () => void;
}
